<div class="shift-loops">
    <div class="loops-container"  #scroll (scroll)="onScroll()">
        <app-main-table class="mt-data-table " [tableConfig]="tableConfig"></app-main-table>
    </div>
    <div class="shadow" 
        [ngClass]="{'shadow-bottom' : !disableShadowBottom,
                    'shadow-top': !disableShadowTop,
                    'shadow-top-bottom': !disableShadowTopBottom}"
        [style.width.px]="widthScrollContainer"></div>
</div>